import React from "react";
import {
  getJobCentreNameByVacancy,
  getJobTitleNameForCandidate,
} from "../../../../services/candidateJobsService";
import { TJobData } from "../../../../store/candidate/types";
import { extractSuburbFromAddress } from "../../../../utils/stringUtils";
import CircleTickFill from "../../../UI/Icons/CircleTickFill";
import PopupModal from "../../../UI/Popup";
import { formatTimeframes } from "../../../Vacancy/timeframeApiHelper";

interface JobAcceptedConfirmationModalProps {
  showApplyJobModal: boolean;
  setShowApplyJobModal: React.Dispatch<React.SetStateAction<boolean>>;
  onClickClose?: () => void;
  vacancyData: TJobData;
  handleApplyForJob?: (vacancyData: TJobData) => void;
  onRefresh?: () => void;
  loadDayJobs?: () => void;
  setShowViewModal?: (show: boolean) => void;
  handleView?: (id: number) => void;
  centreId?: number;
  showSingleDayView?: (show: boolean) => void;
}

const JobAcceptedConfirmationModal: React.FC<JobAcceptedConfirmationModalProps> = ({
  showApplyJobModal,
  handleApplyForJob,
  onClickClose,
  setShowApplyJobModal,
  vacancyData,
  onRefresh,
  loadDayJobs,
  setShowViewModal,
  handleView,
  centreId,
  showSingleDayView
}) => {
  const handleClose = () => {
    setShowApplyJobModal(false);
    if (onClickClose) {
      onClickClose();
      
    }
    // showSingleDayView && showSingleDayView(false);
    // setShowViewModal?.(false);
    if (centreId !== undefined) {
      handleView?.(centreId);
    }
    onRefresh && onRefresh();      
    // loadDayJobs && loadDayJobs();
  };

  return (
    <PopupModal
      visible={showApplyJobModal}
      showCloseBtn={true}
      onClickClose={handleClose}
      customWidth={650}
    >
      <div className="gap-20 fs-22">
        <CircleTickFill />
        Your job is now confirmed
      </div>
      <div className="gap-20 fs-13">
        Thank you for accepting this job:{" "}
        {getJobTitleNameForCandidate(vacancyData)} at{" "}
        {getJobCentreNameByVacancy(vacancyData)}, {extractSuburbFromAddress(vacancyData?.centre?.address)}
        {vacancyData?.timeframes &&
          formatTimeframes(vacancyData?.timeframes)?.map(
            (formatedTimeData, index) => {
              const label = formatedTimeData.label;
              const isToday = label.toLowerCase().startsWith("today");
              const isTomorrow = label.toLowerCase().startsWith("tomorrow");
              const showOn = !isToday && !isTomorrow;
              const displayLabel = (isToday || isTomorrow) 
                ? label.charAt(0).toLowerCase() + label.slice(1)
                : label;

              return (
                <span
                  key={index}
                  className={`fs-13 ${
                    formatedTimeData.alert ? "text-alert fw-700" : "fw-400"
                  }`}
                >
                  {showOn ? " on " : " "}{displayLabel}
                </span>
              );
            }
          )}
      </div>
      <div className="gap-20 fs-13">
        This job listing will be moved to your Accepted tab.{" "}
      </div>

      {/* Add your modal content here */}
    </PopupModal>
  );
};

export default JobAcceptedConfirmationModal;
